/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const removeMyPhoneBodyPhoneNumberMin = 8;
export const removeMyPhoneBodyPhoneNumberMax = 32;

export const RemoveMyPhoneBody = zod.object({
  phoneNumber: zod
    .string()
    .min(removeMyPhoneBodyPhoneNumberMin)
    .max(removeMyPhoneBodyPhoneNumberMax)
    .describe('The secondary number to remove'),
});

export type RemoveMyPhoneBody = zod.input<typeof RemoveMyPhoneBody>;
export type RemoveMyPhoneBodyOutput = zod.output<typeof RemoveMyPhoneBody>;
